export default __webpack_public_path__ + "static/media/Miscellaneous11.6bdf131c.jpg";